import edwinPic from "@/public/images/artists/edwin.png";
import { Artist } from "@/types/types";

export const edwin = {
  id: "147",
  name: "Edwin",
  image: edwinPic,
  description: `Edwin's voice has a smooth, laid-back tone that exudes a casual confidence. It carries the depth and resonance needed for rock music but avoids harshness, leaning more into a mellow, introspective quality. There's a touch of vulnerability in the delivery, making it perfect for indie genres—a sound that balances edge with a softer, more reflective undertone. `,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fedwin-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Indie", "Rock", "Folk", "Dance"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 50,
        high: 69,
      },
      sweetSpot: 60,
    },
  },
} as const satisfies Artist;
